(function () {
  const HUE_NAMES = [
    [0, 'Ruby'],
    [22, 'Amber'],
    [48, 'Gold'],
    [75, 'Lime'],
    [130, 'Emerald'],
    [168, 'Teal'],
    [200, 'Ice'],
    [228, 'Sapphire'],
    [262, 'Violet'],
    [290, 'Orchid'],
    [320, 'Magenta'],
    [345, 'Ruby']
  ];

  function hsl(h) {
    const s = 0.92;
    const l = 0.58;
    const k = (n) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    const to = (x) => Math.round(x * 255).toString(16).padStart(2, '0');
    return '#' + to(f(0)) + to(f(8)) + to(f(4));
  }

  function hueName(h) {
    let name = HUE_NAMES[0][1];
    for (const [deg, label] of HUE_NAMES) {
      if (h >= deg) name = label;
    }
    return name;
  }

  function hueFromEvent(wheel, event) {
    const rect = wheel.getBoundingClientRect();
    const dx = event.clientX - (rect.left + rect.width / 2);
    const dy = event.clientY - (rect.top + rect.height / 2);
    let deg = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
    if (deg < 0) deg += 360;
    return Math.round(deg) % 360;
  }

  function updateKnob(knob, hue) {
    const rad = ((hue - 90) * Math.PI) / 180;
    const radius = 'calc(50% - 19px)';
    knob.style.left = 'calc(50% + ' + Math.cos(rad).toFixed(4) + ' * ' + radius + ')';
    knob.style.top = 'calc(50% + ' + Math.sin(rad).toFixed(4) + ' * ' + radius + ')';
  }

  function setHue(section, hue) {
    const color = hsl(hue);
    section.style.setProperty('--vinoglow-wheel-color', color);
    section.style.setProperty('--vinoglow-wheel-hue', String(hue));

    const wheel = section.querySelector('[data-vinoglow-wheel-control]');
    const colorName = section.querySelector('[data-vinoglow-wheel-color-name]');
    const knob = section.querySelector('[data-vinoglow-wheel-knob]');

    if (wheel) wheel.setAttribute('aria-valuenow', String(hue));
    if (colorName) colorName.textContent = hueName(hue);
    if (knob) updateKnob(knob, hue);
  }

  function initVinoglowWheel(root) {
    const section = root.matches('[data-vinoglow-wheel]') ? root : root.querySelector('[data-vinoglow-wheel]');
    if (!section) return;

    const wheel = section.querySelector('[data-vinoglow-wheel-control]');
    if (!wheel) return;

    let hue = parseInt(section.dataset.defaultHue || '340', 10);
    if (Number.isNaN(hue)) hue = 340;

    let dragging = false;

    setHue(section, hue);

    function applyHue(nextHue) {
      hue = ((nextHue % 360) + 360) % 360;
      setHue(section, hue);
    }

    wheel.addEventListener('pointerdown', (event) => {
      dragging = true;
      if (wheel.setPointerCapture) wheel.setPointerCapture(event.pointerId);
      applyHue(hueFromEvent(wheel, event));
    });

    wheel.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      applyHue(hueFromEvent(wheel, event));
    });

    wheel.addEventListener('pointerup', () => {
      dragging = false;
    });

    wheel.addEventListener('pointercancel', () => {
      dragging = false;
    });

    wheel.addEventListener('keydown', (event) => {
      const step = event.shiftKey ? 15 : 4;
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        event.preventDefault();
        applyHue(hue + step);
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        event.preventDefault();
        applyHue(hue - step);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vinoglow-wheel]').forEach(initVinoglowWheel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initVinoglowWheel(event.target);
  });
})();
